import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=2130c8b3&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"
import "./Companies.vue?vue&type=style&index=0&id=2130c8b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2130c8b3",
  null
  
)

export default component.exports